import * as R from 'ramda';
import { MainTitle } from 'src/types';
import { BookingTestId, DateRangePickerTestId, DeliveryNoteTestId, DiagnosisRecordsTestId, DiagnosisTestId, EditBasicDataModalTestId, EditOrgClientProfileModalTestId, GeneralTableTestId, LoginTestId, MeasurementTestId, PrintSoapTestId, TblTestId, TimelineTestId, UltrasoundTestId, UserProfileTestId } from './keys';
export var testIdConfig = {
  login: LoginTestId,
  booking: BookingTestId,
  generalTable: GeneralTableTestId,
  diagnosisRecords: DiagnosisRecordsTestId,
  userprofile: UserProfileTestId,
  editOrgClientProfileModal: EditOrgClientProfileModalTestId,
  editBasicDataModal: EditBasicDataModalTestId,
  clientTab: MainTitle,
  timeline: TimelineTestId,
  diagnosis: DiagnosisTestId,
  printSoap: PrintSoapTestId,
  ultrasound: UltrasoundTestId,
  measurement: MeasurementTestId,
  deliverynote: DeliveryNoteTestId,
  dateRangePicker: DateRangePickerTestId,
  tbl: TblTestId
};
export var mapTestIDs = function mapTestIDs(key) {
  return R.mapObjIndexed(function (it, k) {
    return "".concat(key, ".").concat(k);
  });
}; // Type-safe testIDs, typescript cannot generate Type-safe testIDs from dynamic key hance we approach with static key
// You can generate the follow code by ChatGPT

var dataTestID = {
  login: mapTestIDs('login')(testIdConfig['login']),
  booking: mapTestIDs('booking')(testIdConfig['booking']),
  generalTable: mapTestIDs('generalTable')(testIdConfig['generalTable']),
  diagnosisRecords: mapTestIDs('diagnosisRecords')(testIdConfig['diagnosisRecords']),
  userprofile: mapTestIDs('userprofile')(testIdConfig['userprofile']),
  editOrgClientProfileModal: mapTestIDs('editOrgClientProfileModal')(testIdConfig['editOrgClientProfileModal']),
  editBasicDataModal: mapTestIDs('editBasicDataModal')(testIdConfig['editBasicDataModal']),
  clientTab: mapTestIDs('clientTab')(testIdConfig['clientTab']),
  timeline: mapTestIDs('timeline')(testIdConfig['timeline']),
  diagnosis: mapTestIDs('diagnosis')(testIdConfig['diagnosis']),
  printSoap: mapTestIDs('printSoap')(testIdConfig['printSoap']),
  ultrasound: mapTestIDs('ultrasound')(testIdConfig['ultrasound']),
  measurement: mapTestIDs('measurement')(testIdConfig['measurement']),
  deliverynote: mapTestIDs('deliverynote')(testIdConfig['deliverynote']),
  dateRangePicker: mapTestIDs('dateRangePicker')(testIdConfig['dateRangePicker']),
  tbl: mapTestIDs('tbl')(testIdConfig['tbl'])
};
export default dataTestID;